module.exports = __webpack_public_path__ + "static/media/whatsapp-icon-buttom.94015370.svg";